function validationIcon(route: any) {
  if (route.name === 'ProfileStack') {
    return 'account-cog-outline';
  }
  if (route.name === 'TokensStack') {
    return 'generating-tokens';
  }
  if (route.name === 'GavelOnlineScreen') {
    return 'gavel';
  }

  return 'home-variant-outline';
}

function validationName(route: any) {
  if (route.name === 'GavelOnlineScreen') {
    return 'Leilão online';
  }
  if (route.name === 'ProfileStack') {
    return 'Perfil';
  }
  if (route.name === 'TokensStack') {
    return 'Tokens';
  }

  return 'Início';
}

export default {
  validationIcon,
  validationName,
};
